// extracted by mini-css-extract-plugin
export default {"storyDetailListWrapper":"c-r_fQ","storyDetailListWrapper__title":"c-r_fR","storyDetailListWrapper__timeline":"c-r_fS","storyDetailListWrapper__list":"c-r_fT"};